import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconProductComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Product${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 20 20" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M7.673 5A2 2 0 005.68 6.834l-.5 6A2 2 0 007.173 15h5.653a2 2 0 001.993-2.166l-.5-6A2 2 0 0012.326 5H7.673zm1.07 2.441c0-.244-.21-.441-.471-.441-.26 0-.472.197-.472.441v.831c0 1.161 1.007 2.103 2.25 2.103s2.25-.942 2.25-2.103v-.831c0-.244-.211-.441-.472-.441-.26 0-.472.197-.472.441v.831c0 .674-.585 1.22-1.306 1.22-.721 0-1.306-.546-1.306-1.22v-.831z"/></svg>;
}

const IconProduct = React.forwardRef(IconProductComponent);
export default IconProduct;
